import _ from 'lodash';
import fpSet from 'lodash/fp/set';
import fpUnset from 'lodash/fp/unset';
import { toEpochMillis } from './date.helpers';

type ScorePath = readonly (string | number)[];

export const revertFailedScoreWrite = <T extends object>(hash: T, path: ScorePath, loggedAt: Date): T => {
  // A hash rebuilt from the buffer holds loggedAt as a JSON string, not a Date.
  const current = _.get(hash, path) as { loggedAt?: Date | string } | undefined;
  return current?.loggedAt && toEpochMillis(current.loggedAt) === loggedAt.getTime() ? fpUnset(path, hash) : hash;
};

export const restoreFailedScoreRemoval = <T extends object>(hash: T, path: ScorePath, previous?: unknown): T =>
  previous && !_.get(hash, path) ? fpSet(path, previous, hash) : hash;
